const Header = () => {
    return (
        <header className="font-helvetica px-8 pt-12 pb-4">
            <div className="mx-auto max-w-6xl">
                <h1 className="text-4xl font-bold tracking-tight text-[#1a1a1a] sm:text-5xl">
                    New York City 2026
                </h1>

                <p className="mt-1 text-sm font-semibold tracking-wide text-gray-500 uppercase">
                    June 16–20, 2026
                </p>
            </div>
        </header>
    )
}

export default Header
